import React from "react";
import { Route } from "react-router-dom";
import { useSelector } from "react-redux";
import Header from "../header/Header";
import Content from "../content/Content";
import SideBar from "./SideBar";
import Footer from "../footer/Footer";
import RangeBox from "../../range/RangeBox";
import LoadQueueNotify from "../../LoadQueue/LoadQueueNotify";
import Overlay from "./Overlay";

const MainLayout = ({ children, match }) => {
  const planTypeId = useSelector(state => state.plan.selectedPlanType);
  const hidePlanTypeIds = [1, 3, 10];

  return (
    <div className="main-layout">
      <Overlay />
      <Header>
        {(!hidePlanTypeIds.includes(planTypeId)) && <Route path={match.path} component={LoadQueueNotify} />}
        <Route path={match.path} component={RangeBox} />
      </Header>
      <div className="main-wrapper">
        <SideBar match={match} />
        <Content>{children}</Content>
        <Footer />
      </div>
    </div>
  );
};

export default MainLayout;